import { defineStore } from 'pinia';

export const useNotificationStore = defineStore('notifications', {
  // arrow function recommended for full type inference
  state: () => ({
    snackbar: false,
    message: ''
  }),
  actions: {
    setSnackbar(snackbar: boolean) {
      this.snackbar = snackbar;
    },
    setMessage(value: string) {
      this.snackbar = true;
      this.message = value;
    }
  }
});
